import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { IntelligenceDiagram } from './IntelligenceDiagram';
import { easeOutStrong } from '../../utils/motion';
export function HomeHero() {
  const scrollToWork = () => {
    document.getElementById('what-we-build')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-white border-b border-line pt-32 pb-20 lg:pt-44 lg:pb-28" data-id="element-844" data-mp="296n5moxx0hpb">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-10 items-center" data-id="element-845" data-mp="2wuwwi59zjvnb">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOutStrong
      }} className="lg:col-span-7" data-id="element-846" data-mp="2n4bpbtg8xiss">
          <h1 className="font-heading font-extrabold text-5xl sm:text-6xl lg:text-7xl text-ink-dark leading-[1.03] tracking-tight" data-id="element-847" data-mp="3ft97zxoddhm2">
            Building Intelligence in the World
          </h1>
          <p className="mt-8 text-xl lg:text-2xl text-ink-dark/80 leading-relaxed max-w-2xl" data-id="element-848" data-mp="ov8rx6r3q7rv">
            SyNeural builds tools that help people think more clearly,
            organizations work with knowledge, and institutions make better
            decisions. We connect human capability development with the systems
            needed to organize evidence and put it to use.
          </p>
          <p className="mt-5 text-base lg:text-lg text-ink-muted leading-relaxed max-w-2xl" data-id="element-849" data-mp="17lqf6vt60b5u">
            Our work includes the Civic Judgment Index (CJI), the Neurocognitive
            Civic Judgment Index (NCJI), and semantic knowledge platforms for
            research and institutional learning.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4" data-id="element-850" data-mp="1cl337jvrvoa0">
            <button type="button" onClick={scrollToWork} className="inline-flex items-center justify-center gap-2 bg-navy hover:bg-navy-light text-white font-medium px-6 py-3.5 rounded-md transition-colors duration-150 shadow-sm whitespace-nowrap" data-id="element-851" data-mp="1cip5f39pjxyr">
              Explore Our Work
              <ArrowRight size={18} data-id="element-852" data-mp="1ma3p5kbohgr9" />
            </button>
            <a href="#contact" className="inline-flex items-center justify-center border border-navy text-navy hover:bg-surface-muted font-medium px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap" data-id="element-853" data-mp="1mcpuref0dm6u">
              Start a Conversation
            </a>
          </div>
        </motion.div>

        <div className="lg:col-span-5" data-id="element-854" data-mp="258pq8z7737v6">
          <IntelligenceDiagram data-id="element-855" data-mp="257of6uq6ildg" />
        </div>
      </div>
    </section>;
}